import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { sharedStore } from '../../stores/SharedStore';
import { Route, Switch } from 'react-router';
import { routes } from '../../data/routes';
import { TranslationExport } from './TranslationExport';
import { TranslationImport } from './TranslationImport';
import { UndoableNavLink } from '../editor/Header';
import { useTranslation } from 'react-i18next';
import { TranslationStats } from './TranslationStats';
import { MakeshiftTranslationSystemDataDisplay } from './MakeshiftTranslationSystemDataDisplay';
const Container = styled.div.withConfig({
  displayName: "TranslationManagement__Container",
  componentId: "sc-1h0kqhg-0"
})(["padding:1em;padding-top:2em;user-select:text;"]);
export const TranslationManagement = observer(() => {
  const {
    t
  } = useTranslation();
  if (!sharedStore.isInitialized) return null;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UndoableNavLink, {
    to: routes.translationManagementExport
  }, t("translation.export")), /*#__PURE__*/React.createElement(UndoableNavLink, {
    to: routes.translationManagementImport
  }, t("translation.import")), /*#__PURE__*/React.createElement(UndoableNavLink, {
    to: routes.translationManagementStats
  }, t("translation.stats")), /*#__PURE__*/React.createElement(UndoableNavLink, {
    to: routes.translationManagementMakeshiftTranslationSystem
  }, t("translation.makeshift_translation_system"))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: routes.translationManagementExport,
    component: TranslationExport
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.translationManagementImport,
    component: TranslationImport
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.translationManagementStats,
    component: TranslationStats
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.translationManagementMakeshiftTranslationSystem,
    component: MakeshiftTranslationSystemDataDisplay
  })));
});